import { IconChevronLeft } from "@tabler/icons-react";
import Tooltip from "components/Tooltip";
import { useTranslation } from "react-i18next";
import React from "react";
import { epdSearchStore } from "features/EPDSearchModal/EPDSearchStore";
import { observer } from "mobx-react-lite";
import { searchStore } from "features/ProductSearch/SearchStore";

export default observer(function ModalTitle(): React.ReactNode {
  const { t } = useTranslation();

  if (epdSearchStore.isExternalSearch) {
    return (
      <>
        <div className="flex items-center">
          <IconChevronLeft
            className="mr-2 cursor-pointer"
            onClick={() => epdSearchStore.setIsExternalSearch(false)}
            size={20}
          />
          {t("productEditor.searchEPDTitle")}
        </div>
        <Tooltip
          content={t("productEditor.2050SearchTooltip")}
          className="text-gray-600 mr-2"
        ></Tooltip>
      </>
    );
  }

  if (searchStore.openEPDSearch.state) {
    return (
      <div className="flex items-center">
        <IconChevronLeft
          className="mr-2 cursor-pointer"
          onClick={() => {
            searchStore.setOpenProductSearch({
              state: true,
              term: searchStore.openEPDSearch.term,
            });
            searchStore.setOpenEPDSearch({
              state: false,
              term: "",
            });
          }}
          size={20}
        />
        {t("productEditor.searchEPDAndSelect")}
      </div>
    );
  }

  return t("productEditor.searchEPDAndSelect");
});
